var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "policy-finder" }, [
    _c("div", { staticClass: "progress-bar-container" }, [
      _c("div", {
        staticClass: "progress-bar-fill",
        style: { width: _vm.progressPercentage + "%" },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "progress-title" }, [
      _c("p", [
        _vm._v(
          _vm._s(_vm.currentStep + 1) +
            "/" +
            _vm._s(_vm.parsedData.length) +
            " - " +
            _vm._s(_vm.parsedData[_vm.currentStep].title)
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.currentStep === 0
      ? _c("div", [
          _c("h2", { staticClass: "step-title" }, [
            _vm._v(_vm._s(_vm.parsedData[0].question)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "step-description" }, [
            _vm._v(_vm._s(_vm.parsedData[0].description)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ctas step-ctas" },
            _vm._l(_vm.parsedData[0].options, function (option, index) {
              return _c("secondary-button", {
                key: index + "_0",
                attrs: {
                  link: { url: "#", target: "_self", title: option.label },
                  label: option.label,
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.nextStep(option.value)
                  },
                },
              })
            }),
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.currentStep === 1
      ? _c("div", [
          _c("h2", { staticClass: "step-title" }, [
            _vm._v(_vm._s(_vm.parsedData[1].question)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "step-description" }, [
            _vm._v(_vm._s(_vm.parsedData[1].description)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ctas step-ctas" },
            _vm._l(_vm.parsedData[1].options, function (option, index) {
              return _c("secondary-button", {
                key: index + "_1",
                attrs: {
                  link: { url: "#", target: "_self", title: option.label },
                  label: false,
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.nextStep(option.value)
                  },
                },
              })
            }),
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.currentStep === 2 && !_vm.selectedOptions.includes("strataManaged")
      ? _c("div", [
          _c("h2", { staticClass: "step-title" }, [
            _vm._v(_vm._s(_vm.parsedData[2].question)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "step-description" }, [
            _vm._v(_vm._s(_vm.parsedData[2].description)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ctas step-ctas" },
            _vm._l(_vm.parsedData[2].options, function (option, index) {
              return _c("secondary-button", {
                key: index + "_2",
                attrs: {
                  link: { url: "#", target: "_self", title: option.label },
                  label: false,
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.nextStep(option.value)
                  },
                },
              })
            }),
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.currentStep === 3 ||
    (_vm.currentStep === 2 && _vm.selectedOptions.includes("strataManaged"))
      ? _c("div", [
          _vm.parsedData[3].options
            ? _c(
                "div",
                { staticClass: "option-wrapper" },
                _vm._l(_vm.parsedData[3].options, function (option, index) {
                  return _c("div", { key: index }, [
                    _vm.isOptionValid(option.value) && option.icon
                      ? _c("img", {
                          attrs: { src: option.icon, alt: option.label },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOptionValid(option.value) && option.label
                      ? _c("h3", {
                          domProps: { innerHTML: _vm._s(option.label) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOptionValid(option.value) && option.description
                      ? _c("p", {
                          domProps: { innerHTML: _vm._s(option.description) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOptionValid(option.value)
                      ? _c(
                          "div",
                          { staticClass: "ctas" },
                          [
                            _c("primary-button", {
                              attrs: {
                                link: option.primary_cta,
                                label: "Get a Quote",
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(
                              option.secondary_ctas,
                              function (cta, index) {
                                return _c("secondary-button", {
                                  key: index,
                                  attrs: {
                                    link: cta.secondary_cta,
                                    label: cta.secondary_cta.title,
                                  },
                                })
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ])
                }),
                0
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ctas bottom" },
      [
        _vm.currentStep > 0 && _vm.currentStep != 3
          ? _c("tertiary-button", {
              attrs: {
                link: { url: "#", target: "_self", title: "Back" },
                label: "Back",
                type: "back",
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.prevStep.apply(null, arguments)
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === 3
          ? _c("secondary-button", {
              attrs: {
                link: { url: "#", target: "_self", title: "Reset Quiz" },
                label: "Reset Quiz",
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.resetForm.apply(null, arguments)
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }